import { Component } from '@angular/core';
import {select, Store} from "@ngrx/store";
import {MsalService} from "@azure/msal-angular";
import {UsersSelectors} from "../../../store/selectors";
import {UsersActions} from "../../../store/actions";

@Component({
  selector: 'searchbar-controller',
  templateUrl: './searchbar-controller.component.html',
  styleUrls: ['./searchbar-controller.component.scss']
})
export class SearchbarControllerComponent {
  loggedInUser$ = this._store.pipe(select(UsersSelectors.getLoggedInUser));

  constructor(
    private _store: Store,
    private msalService: MsalService,
  ) {
    // Only fetch the current user once MSAL actually has an account - otherwise this
    // races MsalGuard's own login redirect (both try to trigger interaction at once,
    // which MSAL rejects with interaction_in_progress instead of redirecting).
    if (this.msalService.instance.getAllAccounts().length > 0) {
      this._store.dispatch(UsersActions.getLoggedInUser());
    }
  }

}
